export enum ProjectEvents {
  'CREATED_PROJECT' = 'project/created',
  'EDITED_PROJECT' = 'project/edited',
  'DELETED_PROJECT' = 'project/deleted',
  'ARCHIVED_PROJECT' = 'project/archived',
  'RELOAD_PROJECTS' = 'reload/projects',
}
